import WeekDayCheckbox from './WeekDayCheckbox';

export default WeekDayCheckbox;
